import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './api/newsletter' // Initialize newsletter API

createRoot(document.getElementById("root")!).render(<App />);
